/// <reference path="../../typings/tsd.d.ts" />
module warsApp.models {
  declare var batchJobDashboardModelActionSelf: BatchJobDashboardModel;

  export class BatchJobDashboardModel {
    batchJobDtos: Wars.Domain.Model.Dtos.BatchJobDto[];

    constructor(
      private scope: angular.IScope,
      private growlService: angular.growl.IGrowlService,
      private batchJobDashboardService: services.BatchJobDashboardService) {
      batchJobDashboardModelActionSelf = this;
      batchJobDashboardModelActionSelf.batchJobDashboardService.getBatchJobExecutions()
        .then((batchJobExecutions) => {
          batchJobDashboardModelActionSelf.batchJobDtos = batchJobExecutions;
        });
    }
  }
}